<template>
  <v-container fluid>
    <v-card>
      <v-system-bar
        >Stundenplan Wünsche
        {{ term ? term.fullText : "Kein Semester ausgewählt" }}</v-system-bar
      >
      <v-toolbar flat>
        <span>{{ wishes.length }} Wünsche von Lehrpersonen:</span>
        <v-spacer></v-spacer>
        <TermPicker
          v-model="term"
          outlined
          depressed
          :range="[-3, 1]"
        ></TermPicker>
      </v-toolbar>
      <v-divider></v-divider>
      <v-list>
        <v-list-item
          v-for="wish in wishes"
          :key="wish.id"
          :to="{ name: 'TimetableWishDetails', params: { id: wish.id } }"
        >
          <v-list-item-content>
            <PersonItemBasic :value="wish.teacher" />
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>{{
              wish.submitted ? "mdi-check-circle" : "mdi-circle-outline"
            }}</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
    <router-view />
  </v-container>
</template>
<script>
import { defineComponent } from "vue";
import PersonItemBasic from "common/components/PersonItemBasic.vue";
import TermPicker from "common/components/TermPicker.vue";
export default defineComponent({
  name: "Timetable",
  components: { PersonItemBasic, TermPicker },
  data() {
    return {
      loading: false,
      wishes: [],
      term: null,
    };
  },
  computed: {},
  watch: {
    term() {
      this.fetchData();
    },
  },
  async created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.wishes = await this.apiList({
        resource: "teacher/wish",
        query: `term=${this.term ? this.term.id : null}`,
      });
      this.loading = false;
    },
  },
});
</script>
